module.exports = __webpack_public_path__ + "static/pie1-7654ba67c78165f2c0b2d3487bccc088.png";